import type { AnyAction } from 'redux';
import { select, take, takeEvery } from 'redux-saga/effects';
import {
  containerSelector,
  userTokenSelector,
} from '../../reducers/app/params';
import {
  CHANGE_USER_BALANCE,
  SET_PARAM_USER_TOKEN,
} from '@corefront/redux-aba';
import { frameMessageLogger } from '../../../pages/GamePage/utils';
import { CUSTOM_EVENT_IDS } from '../../../constants/customEvents';

export function* changeUserBalanceWorker(action: AnyAction) {
  const container: ReturnType<typeof containerSelector> = yield select(
    containerSelector
  );
  const changeUserBalanceEvent = new CustomEvent(
    CUSTOM_EVENT_IDS.ChangeUserBalance,
    {
      detail: {
        data: action?.payload?.new,
      },
      bubbles: true,
    }
  );
  const DOM_NODE = document.querySelector(container);
  frameMessageLogger.log(`Dispatching event with new user balance`);
  DOM_NODE?.dispatchEvent?.(changeUserBalanceEvent);
}

export function* changeUserBalanceWatcher() {
  yield take(SET_PARAM_USER_TOKEN);
  const token: ReturnType<typeof userTokenSelector> = yield select(
    userTokenSelector
  );

  if (token) {
    yield takeEvery(CHANGE_USER_BALANCE, changeUserBalanceWorker);
  }
}
